<div class="site-providers-view full-height layout-column">

  <div class="provider-tabs-row layout-row layout-align-start-center">

    <div class="provider-tabs layout-row flex">
      <button *ngFor="let tab of tabs"
              class="provider-tab br-body-2 flex"
              [class.selected]="tab.kind === selectedKind"
              (click)="onSelectTab(tab.kind)">
        {{ tab.label | translate }}
      </button>
    </div>

    <bringoz-button *ngxPermissionsOnly="'settings.create'"
                    class="margin-right-10"
                    [theme]="'secondary'"
                    (onClick)="onAddProvider($event)">
      <div class="layout-row layout-align-center-center gap-5">
        <bringoz-icon iconName="plus" [classSize]="'sm'"></bringoz-icon>
        <span>{{ 'Add Provider' | translate }}</span>
      </div>
    </bringoz-button>

  </div>

  <app-site-providers-table class="flex"
                            [providers]="providers"
                            [isLoading]="isLoading"
                            (onEdit)="onEditProvider($event)"
                            (onArchive)="onArchiveProvider($event)"
                            (onActiveChange)="onActiveChange($event)">
  </app-site-providers-table>

</div>
